import Logger from "./logger";
import Upsell from "./upsell";

export default function Sidecart() {
  const upsell = new Upsell();
  const domains = ['eu','ca', 'intl', 'us'];
  const head = document.getElementsByTagName('head')[0];
  const sidecartEl = document.querySelector('#shopify-section-sidecart');
  const itemsWrap = sidecartEl.querySelector('.sidecart__items-wrap');
  const uppsellWrap = sidecartEl.querySelector('.sidecart__upsell-wrap');
  const header = sidecartEl.querySelector('.sidecart__header');
  const checkoutBtn = sidecartEl.querySelector('[data-checkout]');
  const subtotalEL = sidecartEl.querySelector('#sidecart-subtotal-price');
  const currencySymbols = {USD: '$', CAD: '$', EUR: '€'};
  const closeBtns = sidecartEl.querySelectorAll('[data-close-sidecart]');
  let addToCartBtns = document.querySelectorAll('[data-add-to-cart]');
  const showCartBtns = document.querySelectorAll('[data-open-sidecart]');
  const host = 'choosemuse.com';
  let countryCode;
  let removeBtns;
  let incrementBtns;
  let decrementBtns;
  let quantityInputs;
  let lineItemPrices;
  let show = false;
  let script;
  let iframe;

  function showToggle(e, supressGetCart = false) {
    show = !show;
    Logger.info(`Sidecart > showToggle; ${show}`);
    sidecartEl.dataset.show = show;
    document.body.dataset.modalMode = show;
		document.documentElement.dataset.modalMode = show;
    if (show && !supressGetCart) getCart();
  }

  function onIncrement(e) {
    const id = e.target.dataset.lineItemId;
    const input = quantityInputs.find(el => el.dataset.lineItemId == id);
    let quantity = parseInt(input.value);
    quantity++;
    updateCart(id, quantity);
  }

  function onDecrement(e) {
    const id = e.target.dataset.lineItemId;
    const input = quantityInputs.find(el => el.dataset.lineItemId == id);
    let quantity = parseInt(input.value);
    if (quantity) {
      quantity--;
      updateCart(id, quantity);
    }
  }

  function onRemove(e) {
    updateCart(e.target.dataset.lineItemId, 0);
  }

  function onInputChange(e) {
    updateCart(e.target.dataset.lineItemId, e.target.value)
  }

  function addCartListeners() {
    /* Logger.info('Sidecart > addCartListeners'); */
    if (removeBtns) removeBtns.forEach((btn) => btn.removeEventListener('click', onRemove));
    if (incrementBtns) incrementBtns.forEach((btn) => btn.removeEventListener('click', onIncrement));
    if (decrementBtns) decrementBtns.forEach((btn) => btn.removeEventListener('click', onDecrement));
    if (quantityInputs) quantityInputs.forEach((input) => input.removeEventListener('change', onInputChange));
    if (addToCartBtns) addToCartBtns.forEach((btn) => btn.removeEventListener('click', addToCartCallback));
    //
    removeBtns = sidecartEl.querySelectorAll('[data-remove-from-sidecart]');
    incrementBtns = sidecartEl.querySelectorAll('[data-line-item-increment]');
    decrementBtns = sidecartEl.querySelectorAll('[data-line-item-decrement]');
    quantityInputs = Array.from(sidecartEl.querySelectorAll('[data-line-item-quantity]'));
    lineItemPrices = Array.from(sidecartEl.querySelectorAll('[data-line-item-price]'));
    addToCartBtns = document.querySelectorAll('[data-add-to-cart]');
    //
    removeBtns.forEach((btn) => btn.addEventListener('click', onRemove));
    incrementBtns.forEach((btn) => btn.addEventListener('click', onIncrement));
    decrementBtns.forEach((btn) => btn.addEventListener('click', onDecrement));
    quantityInputs.forEach((input) => input.addEventListener('change', onInputChange));
    addToCartBtns.forEach((btn) => btn.addEventListener('click', addToCartCallback));
  }

  function updateView(cartData) {
    Logger.info('Sidecart > updateView');
    let upsellProducts = [];
    // remove items
    const lineItems = sidecartEl.querySelectorAll('.sidecart__item');
    lineItems.forEach(el => {
      const itemID = el.dataset.lineItemId;
      if (!cartData.items.find(item => item.id == itemID)) {
        el.parentNode.removeChild(el);
      }
    });
    // update / add items
    cartData.items.forEach((item) => {
      const input = quantityInputs.find(el => el.dataset.lineItemId == item.id);
      const priceEl = lineItemPrices.find(el => el.dataset.lineItemId == item.id);
      if (input) {
        input.value = item.quantity;
        priceEl.textContent = `${currencySymbols[cartData.currency]}${(item.final_line_price / 100).toFixed(2)}`;
      } else {
        addLineItem(item, currencySymbols[cartData.currency]);
      }
      upsellProducts = [ ...upsellProducts, ...upsell.getProducts(item.handle, countryCode)];
    });
    Array.from(header.children).forEach(el => el.dataset.cartItemCount = cartData.item_count);
    subtotalEL.textContent = `${currencySymbols[cartData.currency]}${(cartData.total_price / 100).toFixed(2)}`;
    // remove duplicate upsell products
    upsellProducts = [...new Set(upsellProducts.map(p => JSON.stringify(p)))].map(p => JSON.parse(p));
    // filter out products already in cart
    upsellProducts = upsellProducts.filter(p => !cartData.items.find(itm => itm.variant_id === p.id));
    upsell.updateView(upsellProducts, uppsellWrap);
    addCartListeners();
  }

  function addLineItem(item, currencySymbol) {
    const itemDiv = document.createElement('div');
    itemDiv.className = 'sidecart__item';
    itemDiv.dataset.lineItemId = item.id;
    //
    const imageDiv = document.createElement('div');
    imageDiv.className = 'sidecart__item__image';
    if (item.image) imageDiv.style.backgroundImage = `url(${item.image}&width=130)`;
    itemDiv.appendChild(imageDiv);
    //
    const infoDiv = document.createElement('div');
    infoDiv.className = 'sidecart__item__info';
    //
    const title = document.createElement('p');
    title.className = 'sidecart__item__info__title';
    title.textContent = item.title;
    infoDiv.appendChild(title);
    //
    const quantDiv = document.createElement('div');
    quantDiv.className = 'sidecart__item__info__quantity-container';
    //
    const decBtn = document.createElement('button');
    decBtn.className = 'sidecart__item__info__quantity-decrement';
    decBtn.type = 'button';
    decBtn.dataset.lineItemDecrement = true;
    decBtn.dataset.lineItemId = item.id;
    decBtn.name = `Remove 1 ${item.title}`;
    quantDiv.appendChild(decBtn);
    //
    const input = document.createElement('input');
    input.className = 'sidecart__item__info__quantity-input';
    input.type = 'number';
    input.min = 0;
    input.setAttribute('aria-label', 'Quantity');
    input.dataset.lineItemQuantity = item.quantity ;
    input.dataset.lineItemId = item.id;
    input.value = item.quantity;
    quantDiv.appendChild(input);
    //
    const incBtn = document.createElement('button');
    incBtn.className = 'sidecart__item__info__quantity-increment';
    incBtn.type = 'button';
    incBtn.dataset.lineItemIncrement = true;
    incBtn.dataset.lineItemId = item.id;
    incBtn.name = `Add 1 ${item.title}`;
    quantDiv.appendChild(incBtn);
    infoDiv.appendChild(quantDiv);
    itemDiv.appendChild(infoDiv);
    //
    const totalDiv = document.createElement('div');
    totalDiv.className = 'sidecart__item__total';
    //
    const priceEl = document.createElement('p');
    priceEl.className = 'sidecart__item__total__price';
    priceEl.dataset.lineItemPrice = true;
    priceEl.dataset.lineItemId = item.id;
    priceEl.textContent = `${currencySymbol}${(item.final_line_price / 100).toFixed(2)}`;
    totalDiv.appendChild(priceEl);
    //
    const removeBtn = document.createElement('button');
    removeBtn.textContent = 'Remove';
    removeBtn.className = 'theme-button theme-button--secondary theme-button--small';
    removeBtn.type = 'button';
    removeBtn.dataset.border = true;
    removeBtn.dataset.removeFromSidecart = true;
    removeBtn.dataset.lineItemId = item.id;
    totalDiv.appendChild(removeBtn);
    itemDiv.appendChild(totalDiv);
    itemsWrap.appendChild(itemDiv);
  }
  
  async function getCart() {
    Logger.info('Sidecart > getCart');
    countryCode = getCookie('_muse_store');
    const hostname = `${countryCode !== 'us' ? countryCode + '.' : ''}${host}`;
    if (hostname === window.location.hostname) {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      updateView(cartData);
    } else {
      getCartJson(hostname);
    }
  }

  function getCartJson(hostname) {
    Logger.info(`Sidecart > getCartJson: ${hostname}`);
    script = document.createElement('script');
    script.src = `https://${hostname}/cart.json?callback=cartJsonCallback`;
    head.appendChild(script);
  }

  function cartJsonCallback(data) {
    updateView(data);
    head.removeChild(script);
  }

  async function updateCart(id, quantity) {
    Logger.info(`Sidecart > updateCart: ${id}, ${quantity}`);
    countryCode = getCookie('_muse_store');
    const hostname = `${countryCode !== 'us' ? countryCode + '.' : ''}${host}`;
    if (hostname === window.location.hostname) {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [id]: quantity
          }
        })
      });
      //
      if (response.ok && response.status === 200) {
        const result = await response.json();
        updateView(result);
      }
    } else {
      const url = `https://${hostname}/cart/change?id=${id}&quantity=${quantity}`;
      updateIframe(url, hostname);
    }
  }

  function addToCartCallback(e) {
    addToCart(e.target.dataset.product_id, 1);
  }

  async function addToCart(id, quantity) {
    Logger.info(`Sidecart > addToCart: ${id}, ${quantity}`);
    countryCode = getCookie('_muse_store');
    const hostname = `${countryCode !== 'us' ? countryCode + '.' : ''}${host}`;
    if (hostname === window.location.hostname) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({id, quantity})
      });
      //
      if (response.ok && response.status === 200) {
        getCart();
        if (!show) showToggle(null, true);
      }
    } else {
      const url = `https://${hostname}/cart/add?id=${id}&quantity=${quantity || 1}`;
      updateIframe(url, hostname);
    }
  }

  function updateIframe(src, hostname) {
    if (!iframe) {
      createIframe(src, hostname);
    } else {
      iframe.onload = () => getCartJson(hostname);
      iframe.setAttribute('src', src);
    }
    /* onload can take a while, try to update fast, use onload as safety */
    setTimeout(() => {
      getCartJson(hostname);
    }, 100);
  }

  function createIframe(src, hostname) {
    iframe = document.createElement('iframe');
    iframe.onload = () => getCartJson(hostname);
    iframe.setAttribute('src', src);
    iframe.setAttribute('style', 'display: none;');
    iframe.setAttribute('id', 'update-cart-iframe');
    iframe.setAttribute('name', 'update-cart-iframe');
    sidecartEl.appendChild(iframe);
  }

  function toCheckout() {
    countryCode = getCookie('_muse_store');
    window.location.href = `https://${countryCode !== 'us' ? countryCode + '.' : ''}${host}/checkout`;
  }

  function getCookie(name) {
		let matches = document.cookie.match(new RegExp(
		  "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? matches[1] : false;
	}
  
  function init() {
    Logger.info('Sidecart > init');
    window.cartJsonCallback = cartJsonCallback;
    sidecartEl.dataset.show = show;
    document.body.dataset.modalMode = show;
		document.documentElement.dataset.modalMode = show;
    checkoutBtn.addEventListener('click', toCheckout);
    closeBtns.forEach((btn) => btn.addEventListener('click', showToggle));
    addToCartBtns.forEach((btn) => btn.addEventListener('click', addToCartCallback));
    showCartBtns.forEach((btn) => btn.addEventListener('click', showToggle));
    addCartListeners();
  }
  
  init();
}